import { Col, Container, Row } from 'react-bootstrap';
import ZeroStates from '../../../../ZeroStates';

const MutualFunds = () => {
    return (
        <Container fluid classname='p-0 px-3'>
            <Row classname='g-0'>
                <Col>
                    <div className='zero-state-alerts zero-state-alerts-xl'>
                        <ZeroStates subTextClass='font-regular font-size3 color-text' subText="Your portfolio seems empty" icon='icon-64 icon-nodata mb-3 mrgauto' />
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default MutualFunds;